import "../i18n";

import { ReactComponent as AfiliatePage } from "assets/Common/icons/affiliate-page.svg";
import { ReactComponent as DownLoadIcon } from "assets/Common/icons/download.svg";
// import { ReactComponent as MemberVipIcon } from "assets/Common/icons/icon-member-vip.svg";
import { ReactComponent as AnnouncementIcon } from "assets/Common/icons/messageIcon.svg";
import { ReactComponent as UplineContactIcon } from "assets/Common/icons/upline-contact.svg";
import HistoryIconImg from "assets/Mobile/icons/historyImg.png";
import WithdrawIconImg from "assets/Mobile/icons/withdraw.png";
import { ReactComponent as HistoryIcon } from "assets/temporary/icons/history.svg";
import { ReactComponent as PromotionIcon } from "assets/temporary/icons/promos.svg";
import { ReactComponent as WithdrawIcon } from "assets/temporary/icons/withdraw.svg";

import { PATH } from "./path";

export interface HeaderMenuStyle {
  id: string;
  icon: any;
  label: string;
  link: string;
  iconImage?: string;
}

export const headerMenu: HeaderMenuStyle[] = [
  // {
  //   id: "affiliate",
  //   icon: AfiliatePage,
  //   label: "Affiliate",
  //   link: PATH.affiliatePage,
  // },
  {
    id: "promos",
    icon: PromotionIcon,
    label: "Promos",
    link: PATH.Promotion,
  },
  {
    id: "download",
    icon: DownLoadIcon,
    label: "Download",
    link: PATH.Download,
  },
  {
    id: "uplineContact",
    icon: UplineContactIcon,
    label: "UplineContact",
    link: "",
  },
  // {
  //   icon: BrandSVG,
  //   label: "AFFRegister",
  //   link: "affiliateRegister",
  // },
  // {
  //   icon: MemberVipIcon,
  //   label: "VIP",
  //   link: PATH.User.myVip,
  // },
];

export const headerMenuMobile: HeaderMenuStyle[] = [
  // {
  //   icon: PromotionIcon,
  //   label: "Promos",
  //   link: PATH.Promotion,
  // },
  // {
  //   icon: BrandSVG,
  //   label: "Brand",
  //   link: PATH.Brand,
  // },
  {
    id: "uplineContact",
    icon: UplineContactIcon,
    label: "header:UplineContact",
    link: "",
  },
  {
    id: "withdraw",
    icon: WithdrawIcon,
    label: "home:Withdraw",
    link: PATH.Withdraw,
    iconImage: WithdrawIconImg,
  },
  {
    id: "history",
    icon: HistoryIcon,
    label: "home:History",
    link: PATH.User.TransactionHistory,
    iconImage: HistoryIconImg,
  },
  {
    id: "messages",
    icon: AnnouncementIcon,
    label: "home:Messages",
    link: PATH.User.Announcement,
  },
];
